import React from "react";
import Styles from './styles.module.scss';
import {useTranslation} from "react-i18next";

const CabinetEventsMain = () => {
    const { t } = useTranslation();
    return (
        <section className={`${Styles.container}`}>
            <div className={`${Styles.contentWrap} ${Styles.ftfCard}`}>
                <div className={`${Styles.contentWrapTitle}`}>{t('События')}</div>
                <div className={`${Styles.contentWrapNote}`}>
                    {t('Здесь будут запускаться Side Events — специальные активности, которые помогут вам заранее отслеживать новые волны хайпа и зарабатывать на них. Следите за обновлениями, подробности появятся совсем скоро.')}
                </div>
            </div>
        </section>
    );
};

export default CabinetEventsMain;